import { CKLayoutGridAuto } from 'clearkit';

import { ConnectClearbitTag } from './Steps/ConnectClearbitTag';
import { ConnectCRM } from './Steps/ConnectCRM';

type ImplementationCardCarouselProps = {
  showAll: boolean;
};

export const ImplementationCardCarousel = ({
  showAll,
}: ImplementationCardCarouselProps) => {
  return (
    <CKLayoutGridAuto as="section" autoRepeat="auto-fit" gap="1.5rem">
      <ConnectCRM forceVisibility={showAll} />
      <ConnectClearbitTag forceVisibility={showAll} />
    </CKLayoutGridAuto>
  );
};
